/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CompareIcon = ({ width = 24, height = 24, hidden = false, title = 'Compare' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M8.25,18.02148h-1c-1.24023,0-2.25-1.00977-2.25-2.25V7.27148c0-1.24023,1.00977-2.25,2.25-2.25h8.5c1.24023,0,2.25,1.00977,2.25,2.25v.97852c0,.41406-.33594.75-.75.75s-.75-.33594-.75-.75v-.97852c0-.41309-.33691-.75-.75-.75H7.25c-.41309,0-.75.33691-.75.75v8.5c0,.41309.33691.75.75.75h1c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M2.75,13.77148c-.41406,0-.75-.33594-.75-.75V4.27148c0-1.24023,1.00977-2.25,2.25-2.25h8.75c.41406,0,.75.33594.75.75s-.33594.75-.75.75H4.25c-.41309,0-.75.33691-.75.75v8.75c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M19.43066,18.37012l-2.59131-2.59131c.4696-.67651.74854-1.49451.74854-2.37842,0-2.30859-1.87891-4.1875-4.1875-4.1875s-4.1875,1.87891-4.1875,4.1875,1.87891,4.1875,4.1875,4.1875c.88391,0,1.7019-.27893,2.37842-.74854l2.59131,2.59131c.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055ZM10.71289,13.40039c0-1.48145,1.20605-2.6875,2.6875-2.6875s2.6875,1.20605,2.6875,2.6875-1.20605,2.6875-2.6875,2.6875-2.6875-1.20605-2.6875-2.6875Z"
      fill="currentColor"
    />
  </svg>`;
};
